import React from 'react';
import styles from './styles.module.css';

// Using dangerouslySetInnerHTML allows the associated javascript to manipulate
// the DOM without React getting upset.
/* eslint-disable max-len */

export function Facebook(): React.ReactElement {
  return (
    <span
      className={styles.button}
      dangerouslySetInnerHTML={{
        __html: `
        <div class="fb-share-button"
          data-layout="button_count"
          data-size="small"
          data-mobile-iframe="true"
        >
          <a class="fb-xfbml-parse-ignore"
            target="_blank"
            href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2Fplugins%2F&amp;src=sdkpreparse"
          >
            Share
          </a>
        </div>
      `,
      }}
    />
  );
}

/* eslint-enable max-len */

export function Script(): string {
  return `
  <div id="fb-root"></div>
  <script>(function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/en_GB/sdk.js#xfbml=1&version=v2.8";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));</script>
`;
}
